/**
 * @fileoverview GET handler for the "/engagement/campaigns/tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementCampaignsTags } from "./constants";
import type { EngagementCampaignsTagsResult } from "./types";

export const getEngagementCampaignsTags = reactQueryFetcherAdapter(
  engagementCampaignsTags,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementCampaignsTagsResult> => {
    return fetch("/engagement/campaigns/tags", "GET", { app_group_id: appGroupId }, { signal });
  }
);
